<template>
  <div>
    <NavAnchor
      :product-name="$t('common.productName.G2d')"
      :spec-url="'/product/fjd-easy-dig-2d-excav-specs'"
      :product-url="'/product/fjd-easy-dig-g21-2d-excav'"
    />
    <section class="area-spec" id="SPECS">
      <div class="pl-360 pr-360">
        <h2 class="m-0 ta-c ff-asb c-26 spec-h2">Specifications</h2>
        <div>
          <img
            class="lazy-image"
            v-lazy="require('@/assets/images/2d-excavator/spec-img.png')"
            width="100%"
            height="100%"
            alt="components"
          />
        </div>
        <!-- specs -->
        <div class="spec-wrap">
          <div class="spec-col">
            <h3>System</h3>
            <div class="col-item">
              <span class="spec-title">Accuracy</span>
              <span class="spec-val">Centimeter Accurancy</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Working Temperature</span>
              <span class="spec-val">-20°C - +65°C</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Power Supply</span>
              <span class="spec-val">9~36V</span>
            </div>
          </div>
          <div class="spec-col">
            <h3>Control Terminal</h3>
            <div class="col-item">
              <span class="spec-title">Size</span>
              <span class="spec-val">300 x 190 x 43 mm</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Screen</span>
              <span class="spec-val">10.1'' LED Touchscreen</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Power Supply</span>
              <span class="spec-val">10-30 V</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Signals Received</span>
              <span class="spec-val">2.4GHz WiFi，BT 5.0</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Working Temperature</span>
              <span class="spec-val">-20℃ - +70℃</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Storage Temperature</span>
              <span class="spec-val">-40℃ - +85℃</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Waterproof Rate</span>
              <span class="spec-val">IP66</span>
            </div>
          </div>

          <div class="spec-col">
            <h3>Wireless Sensor</h3>
            <div class="col-item">
              <span class="spec-title">Size</span>
              <span class="spec-val">119*86*43mm</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Charging Mode</span>
              <span class="spec-val">Battary Charging + Solar Charging</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Charging Voltage</span>
              <span class="spec-val">5V</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Hibernation Mode </span>
              <span class="spec-val">Supported</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Battery Life</span>
              <span class="spec-val">Above 100h </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Charging Time</span>
              <span class="spec-val">≤ 10h </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Battery Capacity</span>
              <span class="spec-val">7800mah</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Operating Temperature</span>
              <span class="spec-val">-20°C - +65°C </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Storage Temperature</span>
              <span class="spec-val">-40°C - +85°C </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Waterproof Rate</span>
              <span class="spec-val">IP66</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Communication Protocol</span>
              <span class="spec-val">CAN</span>
            </div>
            <div class="col-item">
              <span class="spec-title">Effective Communication Distance</span>
              <span class="spec-val">30m</span>
            </div>
          </div>

          <div class="spec-col">
            <h3>Body Sensor</h3>
            <div class="col-item">
              <span class="spec-title">Axes (Tilt)</span>
              <span class="spec-val">Pitch and Roll </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Range</span>
              <span class="spec-val">Pitch ±90°, Roll ±180° </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Resolution</span>
              <span class="spec-val">0.01° </span>
            </div>
            <div class="col-item">
              <span class="spec-title">Max. Angular Velocity</span>
              <span class="spec-val">≤400°/s </span>
            </div>
            <div class="col-item h5-bottom-border">
              <span class="spec-title">Operating voltage</span>
              <span class="spec-val">4.9 V - 32 V </span>
            </div>
            <div class="col-item h5-bottom-border">
              <span class="spec-title">Power</span>
              <span class="spec-val">&lt;400 mW </span>
            </div>
            <div class="col-item h5-bottom-border">
              <span class="spec-title">Operating Temperature</span>
              <span class="spec-val">-40°C - +85°C </span>
            </div>
            <div class="col-item h5-bottom-border">
              <span class="spec-title">Waterproof Rate</span>
              <span class="spec-val">IP68</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import NavAnchor from '@/components/NavAnchor'

  export default {
    components: {
      NavAnchor
    },
    data() {
      return {}
    },
    head() {
      return {
        title: 'FJD Easydig 2D excavator guidance system',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content:
              'grade control,excavator guidance system,2D grade control,2D excavator grade control,2D excavator guidance,system,digital construction,machine control'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'Easydig is a wireless 2D excavator guidance system that leads the industry with centimeter accuracy.'
          }
        ]
      }
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  /* 参数 */
  .spec-h2 {
    margin-top: 0.76rem;
    font-size: 0.48rem;
  }
  .area-spec {
    padding-top: 1.4rem;
  }
  .area-spec h2 {
    margin-bottom: 0.64rem;
  }
  .spec-col {
    margin-bottom: 0.6rem;
  }
  .spec-wrap {
    padding-top: 0.4rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 1.3rem;
  }
  .spec-col {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    width: 4.61rem;
  }
  .col-item {
    line-height: 1.5;
    display: flex;
    justify-content: space-between;
    width: 4.61rem;
    padding: 0.12rem 0;
    border-bottom: 1px solid #ccc;
  }
  .spec-title {
    font-size: 0.18rem;
    font-weight: 500;
    color: #333333;
  }
  .spec-val {
    font-size: 0.18rem;
    font-weight: 400;
    color: #333333;
  }
  .col-item:last-child {
    border-bottom: 1px solid transparent;
  }
</style>
